import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'companyBrands';
export const companyBrandsActions = makeActions(MODEL_NAME);

export const getAllCompanyBrands = companyBrandsActions.getAll;
